import {
  Colors,
  useDynamicStyles,
  type WithResponsive,
} from '@sunrise-ui/primitives';
import React, { type ReactNode } from 'react';
import { StyleSheet, View, type ViewStyle } from 'react-native';

type Props = {
  children: ReactNode;
  style?: ViewStyle;
};

export function SponsorshipCard({ children, style }: Props) {
  const styles = useDynamicStyles(createStyles);

  return <View style={[styles.container, style]}>{children}</View>;
}

const createStyles = ({ isMobile }: WithResponsive) =>
  StyleSheet.create({
    container: {
      backgroundColor: Colors.opacity05,
      borderRadius: isMobile ? 12 : 16,
      padding: isMobile ? 12 : 16,
    },
  });
